<template>
  <v-tooltip top open-delay="500">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :color="color">{{ icon }}</v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
/**
 * Helper component to display an icon with a tooltip.
 */
export default {
  name: 'IconTooltip',
  props: {
    color: {
      type: String
    },
    icon: {
      type: String
    },
    tooltip: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
